import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect, withDirectives as _withDirectives, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, vModelText as _vModelText, createTextVNode as _createTextVNode, vModelRadio as _vModelRadio, createBlock as _createBlock, mergeProps as _mergeProps } from "vue"

const _hoisted_1 = { id: "healthcaredata02-03-a-modal" }
const _hoisted_2 = { class: "modal modal-diagnosis-process-add" }
const _hoisted_3 = { class: "modal-header" }
const _hoisted_4 = { class: "modal-header-title" }
const _hoisted_5 = { class: "modal-body" }
const _hoisted_6 = {
  key: 0,
  class: "diagnosis-process-form step-1"
}
const _hoisted_7 = { class: "diagnosis-process-form-info" }
const _hoisted_8 = { class: "diagnosis-process-form-caution" }
const _hoisted_9 = { class: "diagnosis-process-form-item" }
const _hoisted_10 = { class: "diagnosis-process-form-label" }
const _hoisted_11 = { class: "diagnosis-process-form-label" }
const _hoisted_12 = { class: "diagnosis-process-form-label-required" }
const _hoisted_13 = { class: "diagnosis-process-form-description" }
const _hoisted_14 = { class: "diagnosis-process-form-date-container" }
const _hoisted_15 = { class: "diagnosis-process-form-date-container-year" }
const _hoisted_16 = ["value"]
const _hoisted_17 = { class: "diagnosis-process-form-date-container-month" }
const _hoisted_18 = ["value"]
const _hoisted_19 = { class: "diagnosis-process-form-date-container-day" }
const _hoisted_20 = ["value"]
const _hoisted_21 = { class: "diagnosis-process-form-item" }
const _hoisted_22 = { class: "diagnosis-process-form-label" }
const _hoisted_23 = ["for"]
const _hoisted_24 = {
  key: 0,
  class: "diagnosis-process-form-label-required"
}
const _hoisted_25 = ["id", "placeholder", "onUpdate:modelValue"]
const _hoisted_26 = { class: "diagnosis-process-form-initial-symptoms-add" }
const _hoisted_27 = {
  key: 1,
  class: "diagnosis-process-form-initial-symptoms-limit"
}
const _hoisted_28 = { class: "diagnosis-process-form-item" }
const _hoisted_29 = { class: "diagnosis-process-form-label" }
const _hoisted_30 = { class: "diagnosis-process-form-label-required" }
const _hoisted_31 = { class: "diagnosis-process-form-purpose-container" }
const _hoisted_32 = {
  for: "purpose-yes",
  class: "diagnosis-process-form-purpose-button"
}
const _hoisted_33 = {
  for: "purpose-no",
  class: "diagnosis-process-form-purpose-button"
}
const _hoisted_34 = {
  key: 1,
  class: "diagnosis-process-form step-2"
}
const _hoisted_35 = { class: "diagnosis-process-form-info" }
const _hoisted_36 = { class: "diagnosis-process-form-item" }
const _hoisted_37 = { class: "diagnosis-process-form-label" }
const _hoisted_38 = { class: "diagnosis-process-form-label" }
const _hoisted_39 = { class: "diagnosis-process-form-label-required" }
const _hoisted_40 = { class: "diagnosis-process-form-description" }
const _hoisted_41 = { class: "diagnosis-process-form-date-container" }
const _hoisted_42 = { class: "diagnosis-process-form-date-container-year" }
const _hoisted_43 = ["value"]
const _hoisted_44 = { class: "diagnosis-process-form-date-container-month" }
const _hoisted_45 = ["value"]
const _hoisted_46 = { class: "diagnosis-process-form-date-container-day" }
const _hoisted_47 = ["value"]
const _hoisted_48 = { class: "diagnosis-process-form-item" }
const _hoisted_49 = { class: "diagnosis-process-form-label" }
const _hoisted_50 = { class: "diagnosis-process-form-visit-count-container" }
const _hoisted_51 = ["id", "value"]
const _hoisted_52 = ["for"]
const _hoisted_53 = { class: "diagnosis-process-form-item" }
const _hoisted_54 = { class: "diagnosis-process-form-label" }
const _hoisted_55 = { class: "diagnosis-process-form-description" }
const _hoisted_56 = { class: "diagnosis-process-form-select-area-wrapper" }
const _hoisted_57 = { class: "diagnosis-process-form-item" }
const _hoisted_58 = { class: "diagnosis-process-form-label" }
const _hoisted_59 = { class: "diagnosis-process-form-description" }
const _hoisted_60 = { class: "diagnosis-process-form-select-area-wrapper" }
const _hoisted_61 = { class: "modal-footer" }
const _hoisted_62 = { class: "modal-footer-buttons" }

import { ref, onMounted, computed, reactive, getCurrentInstance } from "vue";
import { _$t } from "@/utils/i18n";
import SelectAreaModal from "./SelectAreaModal.vue";
import { DiagnosisProcess } from "@/models/myRecord/diagnosisProcess";
import ErrorDialog from "@/views/base/CommonMessage.vue";
import { processing, processend } from "@/utils/view";

// ---- Types -------------------------------------------------
// 初期症状の型
type InitialSymptom = {
  subNumber: number; // 枝番
  symptom: string; // 初期症状
};

// 汎用マスタの型（病院訪問数）
type HospitalVisitCountOption = {
  optionId: number; // option_id
  kubun: string; // kubun
  value: string; // value
  displayName: string; // display_name
  sortOrder: number; // sort_order
};

// 経緯データの型
type DiagnosisProcessData = {
  initialSymptomYear: string;
  initialSymptomMonth: string;
  initialSymptomDay: string;
  initialSymptoms: InitialSymptom[]; // 初期症状（別テーブル）
  medicalCheckupStatus: number; // 0: 受けていない, 1: 受けている（v-model.numberで数値）
  diagnosisYear: string;
  diagnosisMonth: string;
  diagnosisDay: string;
  hospitalVisitsCountRangeOptionId: string; // radioから文字列で渡される
  finalDiagPref: string; // 確定診断先の都道府県
  finalDiagCity: string; // 確定診断先の市区郡
  refSourcePref: string; // 紹介元の都道府県
  refSourceCity: string; // 紹介元の市区郡
};

// 経緯データの型（病気情報を含む）
type DiseaseDetailData = {
  diseaseCode: string; // 疾患コード（PKの一部）
  diseaseName: string; // 疾患名（表示用、保存時は除外）
  diagnosisProcess: DiagnosisProcessData | null;
};

interface Props {
  initialData: DiseaseDetailData;
  hospitalVisitCountOptions: HospitalVisitCountOption[];
}

// ---- Variable, Constant ----------------------------------------------
// eslint-disable-next-line no-undef

export default /*@__PURE__*/_defineComponent({
  __name: 'DiagnosisProcessModal',
  props: {
    initialData: {},
    hospitalVisitCountOptions: {}
  },
  emits: ["close", "updateList"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

// eslint-disable-next-line no-undef
const emits = __emit;
const currentStep = ref(1);
const isAreaModalOpen = ref(false);
const areaModalType = ref<"diagnosis" | "referral">("diagnosis");
const fieldErrors = ref<Record<string, string>>({});
const { appContext } = getCurrentInstance()!;
const $toast = appContext?.config.globalProperties.$toast;

// 病気名（表示用）
const diseaseName = computed(() => props.initialData.diseaseName);

// 地域選択モーダルのタイトル
const areaModalTitle = computed(() => {
  return areaModalType.value === "diagnosis"
    ? _$t("diagnosisProcess_label_final_diag_pref")
    : _$t("diagnosisProcess_label_referral_received_pref");
});

// Step1のボタンテキスト
const step1ButtonText = computed(() => {
  // 「受けていない」(0)を選択した場合は「保存」、それ以外は「次へ」
  return diagProcessInput.value.medicalCheckupStatus === 0
    ? _$t("common_button_save")
    : _$t("common_button_next");
});

// 年の選択肢を生成（現在年から過去100年分）
const currentYear = new Date().getFullYear();
const startYear = currentYear - 100;
const years = ref<string[]>([]);
for (let year = currentYear; year >= startYear; year--) {
  years.value.push(String(year));
}

// 初期データの設定（親から渡されたデータを展開）
const diagProcessInput = ref<DiagnosisProcessData>({
  initialSymptomYear:
    props.initialData.diagnosisProcess?.initialSymptomYear || "",
  initialSymptomMonth:
    props.initialData.diagnosisProcess?.initialSymptomMonth || "",
  initialSymptomDay:
    props.initialData.diagnosisProcess?.initialSymptomDay || "",
  initialSymptoms:
    props.initialData.diagnosisProcess?.initialSymptoms &&
    props.initialData.diagnosisProcess.initialSymptoms.length > 0
      ? props.initialData.diagnosisProcess.initialSymptoms
      : [
        { subNumber: 1, symptom: "" },
        { subNumber: 2, symptom: "" },
      ],
  medicalCheckupStatus:
    props.initialData.diagnosisProcess?.medicalCheckupStatus ?? 1,
  diagnosisYear: props.initialData.diagnosisProcess?.diagnosisYear || "",
  diagnosisMonth: props.initialData.diagnosisProcess?.diagnosisMonth || "",
  diagnosisDay: props.initialData.diagnosisProcess?.diagnosisDay || "",
  hospitalVisitsCountRangeOptionId:
    props.initialData.diagnosisProcess?.hospitalVisitsCountRangeOptionId || "",
  finalDiagPref: props.initialData.diagnosisProcess?.finalDiagPref || "",
  finalDiagCity: props.initialData.diagnosisProcess?.finalDiagCity || "",
  refSourcePref: props.initialData.diagnosisProcess?.refSourcePref || "",
  refSourceCity: props.initialData.diagnosisProcess?.refSourceCity || "",
});

// エラーダイアログ関連情報
const sessionErr = ref(false);
let errorDialog = reactive({
  show: false,
  okButtonHide: true,
  safe: false,
  message: "",
  open: (message: string): void => {
    processing(); // オーバレイを表示
    errorDialog.message = message;
    errorDialog.show = true;
  },
  close: (): void => {
    processend(); // オーバレイを非表示
    errorDialog.show = false;
    errorDialog.message = "";
    if (sessionErr.value) {
      window.location.replace("/cms/login");
    }
  },
});

// ----- Function -----------------------------------------------
// 症状を追加
const addSymptom = () => {
  if (diagProcessInput.value.initialSymptoms.length < 20) {
    diagProcessInput.value.initialSymptoms.push({ subNumber: 1, symptom: "" });
  }
};

// Step1の「次へ」または「記録」ボタン押下
const handleStep1Next = () => {
  // バリデーション実行（Step1のデータのみ）
  const diagnosisProcessModel = new DiagnosisProcess();

  // Step1のフィールドのみを抽出してバリデーション
  const step1Data = {
    initialSymptomYear: diagProcessInput.value.initialSymptomYear,
    initialSymptomMonth: diagProcessInput.value.initialSymptomMonth,
    initialSymptomDay: diagProcessInput.value.initialSymptomDay,
    initialSymptoms: diagProcessInput.value.initialSymptoms,
    medicalCheckupStatus: diagProcessInput.value.medicalCheckupStatus,
  };

  diagnosisProcessModel.set(step1Data);
  const validateResult = diagnosisProcessModel.validate();

  if (!validateResult.valid) {
    fieldErrors.value = {};
    (validateResult.errors as Array<{ key: string; msg: string }>).forEach(
      (error) => {
        fieldErrors.value[error.key] = error.msg;
      }
    );
    document.querySelector(".modal-body")?.scrollTo({
      top: 0,
      behavior: "instant",
    });
    return;
  }
  fieldErrors.value = {};

  // 「受けている」(1)を選択した場合はStep2へ進む
  if (diagProcessInput.value.medicalCheckupStatus === 1) {
    goToStep2();
  }
  // 「受けていない」(0)を選択した場合は保存
  else if (diagProcessInput.value.medicalCheckupStatus === 0) {
    openSaveConfirm();
  }
};

// ステップ2へ進む
const goToStep2 = () => {
  currentStep.value = 2;
};

// ステップ1に戻る
const goToStep1 = () => {
  currentStep.value = 1;
};

// 確定診断を受けた病院の所在地選択
const selectDiagnosisLocation = () => {
  areaModalType.value = "diagnosis";
  isAreaModalOpen.value = true;
};

// 紹介を受けた病院の所在地選択
const selectReferralLocation = () => {
  areaModalType.value = "referral";
  isAreaModalOpen.value = true;
};

// 地域選択モーダルを閉じる
const closeAreaModal = () => {
  isAreaModalOpen.value = false;
};

// 地域選択の結果を処理（locationString: "都道府県名 市区町村名", cityName: 市区町村名）
const handleAreaSelect = (
  locationString: string,
  _prefectureCode: string,
  cityName: string
) => {
  const prefName = locationString.split(/\s+/)[0] ?? "";
  if (areaModalType.value === "diagnosis") {
    diagProcessInput.value.finalDiagPref = prefName;
    diagProcessInput.value.finalDiagCity = cityName;
  } else {
    diagProcessInput.value.refSourcePref = prefName;
    diagProcessInput.value.refSourceCity = cityName;
  }
  closeAreaModal();
};

const openSaveConfirm = async () => {
  await saveData();
};

const showSaveCompleteToast = () => {
  if (!$toast) return;
  $toast({
    message: _$t("diagnosisProcess_message_save_complete"),
    icon: "success",
  });
};

// 保存前バリデーション（全フィールド）
const validateBeforeSave = () => {
  // バリデーション実行（全フィールド）
  const diagnosisProcessModel = new DiagnosisProcess();
  diagnosisProcessModel.set({
    ...diagProcessInput.value,
    diseaseCode: props.initialData.diseaseCode,
  });

  const result = diagnosisProcessModel.validate();

  if (!result.valid) {
    fieldErrors.value = {};
    (result.errors as Array<{ key: string; msg: string }>).forEach((error) => {
      fieldErrors.value[error.key] = error.msg;
    });
    document.querySelector(".modal-body")?.scrollTo({
      top: 0,
      behavior: "instant",
    });
    return false;
  }
  fieldErrors.value = {};
  return true;
};

// Step2の保存ボタン押下時：先にバリデーションしてから確認ダイアログを表示
const handleStep2SaveClick = () => {
  if (!validateBeforeSave()) return;
  openSaveConfirm();
};

// 保存処理（確認ダイアログOK後）
const saveData = async () => {
  const diagnosisProcessModel = new DiagnosisProcess();

  // 保存データの準備（疾患コードを含める）
  const saveData = {
    diseaseCode: props.initialData.diseaseCode,
    ...diagProcessInput.value,
  };

  // 「受けていない」を選択した場合、Step2のデータをクリア
  if (saveData.medicalCheckupStatus === 0) {
    saveData.diagnosisYear = "";
    saveData.diagnosisMonth = "";
    saveData.diagnosisDay = "";
    saveData.hospitalVisitsCountRangeOptionId = "";
    saveData.finalDiagPref = "";
    saveData.finalDiagCity = "";
    saveData.refSourcePref = "";
    saveData.refSourceCity = "";
  }

  // 登録・更新
  await diagnosisProcessModel.save(saveData).then(([model, _response, err]) => {
    if (err) {
      const status = err.error?.response?.status;
      const decodedMessage = decodeURIComponent(
        err.error?.response?.data?.message
      );

      // セッションエラー
      if (status === 408) sessionErr.value = true;
      errorDialog.open(decodedMessage);
      return;
    }

    // 成功したら、モーダルを閉じて、親側の一覧を、今回登録・更新したデータで更新
    emits("close");
    emits("updateList");
    showSaveCompleteToast();
  });
};

// 日付選択フォームの制御
onMounted(() => {
  document
    .querySelectorAll(".hospital-visit-calendar-input")
    .forEach((element) => {
      const el = element as HTMLInputElement;
      const wrapper = el.closest(".hospital-visit-calendar-input-wrapper");
      const formattedSpan = wrapper?.querySelector(
        ".hospital-visit-calendar-formatted-date"
      );

      const updateDisplay = () => {
        const hasValue = !!el.value;
        el.classList.toggle("has-value", hasValue);

        if (hasValue && formattedSpan) {
          // 日付をフォーマット（例: 2026-10-07 → 2026年10月7日(水)）
          const date = new Date(el.value + "T00:00:00");
          const year = date.getFullYear();
          const month = date.getMonth() + 1;
          const day = date.getDate();
          const weekdays = ["日", "月", "火", "水", "木", "金", "土"];
          const weekday = weekdays[date.getDay()];

          formattedSpan.textContent = `${year}年${month}月${day}日(${weekday})`;
        } else if (formattedSpan) {
          formattedSpan.textContent = "";
        }
      };

      el.addEventListener("change", updateDisplay);
      el.addEventListener("input", updateDisplay);
      updateDisplay();

      // アイコンクリックでカレンダーを開く
      if (wrapper) {
        wrapper.addEventListener("click", (e) => {
          if (e.target !== el) {
            const inputElement = el as HTMLInputElement & {
              showPicker?: () => void;
            };
            inputElement.showPicker?.();
          }
        });
      }
    });
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("body", null, [
        _cache[22] || (_cache[22] = _createElementVNode("div", { class: "modal-overlay" }, null, -1)),
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, _toDisplayString(_unref(_$t)("diagnosisProcess_label_title")), 1),
            _createElementVNode("button", {
              type: "button",
              class: "modal-close",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
            }, _cache[11] || (_cache[11] = [
              _createElementVNode("img", { src: "/server/necs/images/close-btn.png" }, null, -1)
            ]))
          ]),
          _createElementVNode("div", _hoisted_5, [
            (currentStep.value === 1)
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  _createElementVNode("p", _hoisted_7, _toDisplayString(diseaseName.value) + " " + _toDisplayString(_unref(_$t)("diagnosisProcess_msg_info")), 1),
                  _createElementVNode("p", _hoisted_8, _toDisplayString(_unref(_$t)("diagnosisProcess_label_required")), 1),
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("div", _hoisted_10, [
                      _createElementVNode("label", _hoisted_11, [
                        _createElementVNode("span", null, _toDisplayString(_unref(_$t)("diagnosisProcess_label_initial_symptom_date_2")), 1),
                        _createElementVNode("span", _hoisted_12, _toDisplayString(_unref(_$t)("common_label_required_icon")), 1)
                      ]),
                      _createElementVNode("p", _hoisted_13, _toDisplayString(_unref(_$t)("diagnosisProcess_msg_date_info")), 1)
                    ]),
                    _createElementVNode("div", _hoisted_14, [
                      _createElementVNode("div", _hoisted_15, [
                        _withDirectives(_createElementVNode("select", {
                          name: "diagnosis-process-date",
                          class: "diagnosis-process-form-date-select",
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((diagProcessInput.value.initialSymptomYear) = $event))
                        }, [
                          _cache[12] || (_cache[12] = _createElementVNode("option", {
                            value: "",
                            selected: "",
                            disabled: ""
                          }, "----", -1)),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(years.value, (year) => {
                            return (_openBlock(), _createElementBlock("option", {
                              key: year,
                              value: year
                            }, _toDisplayString(year), 9, _hoisted_16))
                          }), 128))
                        ], 512), [
                          [_vModelSelect, diagProcessInput.value.initialSymptomYear]
                        ]),
                        _createElementVNode("span", null, _toDisplayString(_unref(_$t)("common_label_year")), 1)
                      ]),
                      _createElementVNode("div", _hoisted_17, [
                        _withDirectives(_createElementVNode("select", {
                          name: "diagnosis-process-date",
                          class: "diagnosis-process-form-date-select",
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((diagProcessInput.value.initialSymptomMonth) = $event))
                        }, [
                          _cache[13] || (_cache[13] = _createElementVNode("option", {
                            value: "",
                            selected: "",
                            disabled: ""
                          }, "--", -1)),
                          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(12, (month) => {
                            return _createElementVNode("option", {
                              key: month,
                              value: String(month)
                            }, _toDisplayString(String(month).padStart(2, "0")), 9, _hoisted_18)
                          }), 64))
                        ], 512), [
                          [_vModelSelect, diagProcessInput.value.initialSymptomMonth]
                        ]),
                        _createElementVNode("span", null, _toDisplayString(_unref(_$t)("common_label_month")), 1)
                      ]),
                      _createElementVNode("div", _hoisted_19, [
                        _withDirectives(_createElementVNode("select", {
                          name: "diagnosis-process-date",
                          class: "diagnosis-process-form-date-select",
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((diagProcessInput.value.initialSymptomDay) = $event))
                        }, [
                          _cache[14] || (_cache[14] = _createElementVNode("option", {
                            value: "",
                            selected: "",
                            disabled: ""
                          }, "--", -1)),
                          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(31, (day) => {
                            return _createElementVNode("option", {
                              key: day,
                              value: String(day)
                            }, _toDisplayString(String(day).padStart(2, "0")), 9, _hoisted_20)
                          }), 64))
                        ], 512), [
                          [_vModelSelect, diagProcessInput.value.initialSymptomDay]
                        ]),
                        _createElementVNode("span", null, _toDisplayString(_unref(_$t)("common_label_day")), 1)
                      ])
                    ]),
                    _createElementVNode("div", {
                      class: _normalizeClass(["input-required-error", { active: fieldErrors.value.initialSymptomYear }])
                    }, _toDisplayString(fieldErrors.value.initialSymptomYear), 3)
                  ]),
                  _createElementVNode("div", _hoisted_21, [
                    _createElementVNode("div", _hoisted_22, [
                      _createElementVNode("label", null, [
                        _createElementVNode("span", null, _toDisplayString(_unref(_$t)("diagnosisProcess_label_initial_symptom")), 1)
                      ])
                    ]),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(diagProcessInput.value.initialSymptoms, (symptom, index) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: index,
                        class: "item-row"
                      }, [
                        _createElementVNode("label", {
                          for: 'initial-symptoms-' + index,
                          class: "diagnosis-process-form-initial-symptoms-label"
                        }, [
                          _createElementVNode("span", null, _toDisplayString(_unref(_$t)("diagnosisProcess_label_initial_symptom_symptom")) + " " + _toDisplayString(index + 1), 1),
                          (index === 0)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_24, _toDisplayString(_unref(_$t)("common_label_required_icon")), 1))
                            : _createCommentVNode("", true)
                        ], 8, _hoisted_23),
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          id: 'initial-symptoms-' + index,
                          class: "diagnosis-process-form-initial-symptoms-input",
                          placeholder: 
                    _unref(_$t)('diagnosisProcess_placeholder_initial_symptom')
                  ,
                          "onUpdate:modelValue": ($event: any) => ((diagProcessInput.value.initialSymptoms[index].symptom) = $event)
                        }, null, 8, _hoisted_25), [
                          [_vModelText, diagProcessInput.value.initialSymptoms[index].symptom]
                        ]),
                        (index === 0)
                          ? (_openBlock(), _createElementBlock("div", {
                              key: 0,
                              class: _normalizeClass(["input-required-error", { active: fieldErrors.value.initialSymptoms }])
                            }, _toDisplayString(fieldErrors.value.initialSymptoms), 3))
                          : _createCommentVNode("", true)
                      ]))
                    }), 128)),
                    _createElementVNode("div", _hoisted_26, [
                      (diagProcessInput.value.initialSymptoms.length < 20)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            type: "button",
                            onClick: addSymptom
                          }, [
                            _cache[15] || (_cache[15] = _createElementVNode("img", { src: "/server/necs/images/icon_add_plus_EC7400.svg" }, null, -1)),
                            _createTextVNode(_toDisplayString(_unref(_$t)("diagnosisProcess_button_add_symptom")), 1)
                          ]))
                        : _createCommentVNode("", true),
                      (diagProcessInput.value.initialSymptoms.length >= 20)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_27, _toDisplayString(_unref(_$t)("diagnosisProcess_msg_add_symptom_limit")), 1))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_28, [
                    _createElementVNode("div", _hoisted_29, [
                      _createElementVNode("label", null, [
                        _createElementVNode("span", null, _toDisplayString(_unref(_$t)("diagnosisProcess_label_medical_checkup_status")), 1),
                        _createElementVNode("span", _hoisted_30, _toDisplayString(_unref(_$t)("common_label_required_icon")), 1)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_31, [
                      _withDirectives(_createElementVNode("input", {
                        type: "radio",
                        id: "purpose-yes",
                        name: "purpose",
                        value: 1,
                        class: "diagnosis-process-form-purpose-radio",
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((diagProcessInput.value.medicalCheckupStatus) = $event))
                      }, null, 512), [
                        [
                          _vModelRadio,
                          diagProcessInput.value.medicalCheckupStatus,
                          void 0,
                          { number: true }
                        ]
                      ]),
                      _createElementVNode("label", _hoisted_32, _toDisplayString(_unref(_$t)("diagnosisProcess_label_medical_checkup_status_yes")), 1),
                      _withDirectives(_createElementVNode("input", {
                        type: "radio",
                        id: "purpose-no",
                        name: "purpose",
                        value: 0,
                        class: "diagnosis-process-form-purpose-radio",
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((diagProcessInput.value.medicalCheckupStatus) = $event))
                      }, null, 512), [
                        [
                          _vModelRadio,
                          diagProcessInput.value.medicalCheckupStatus,
                          void 0,
                          { number: true }
                        ]
                      ]),
                      _createElementVNode("label", _hoisted_33, _toDisplayString(_unref(_$t)("diagnosisProcess_label_medical_checkup_status_no")), 1)
                    ]),
                    _createElementVNode("div", {
                      class: _normalizeClass(["input-required-error", { active: fieldErrors.value.medicalCheckupStatus }])
                    }, _toDisplayString(fieldErrors.value.medicalCheckupStatus), 3)
                  ])
                ]))
              : _createCommentVNode("", true),
            (currentStep.value === 2)
              ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                  _createElementVNode("button", {
                    type: "button",
                    class: "diagnosis-process-form-back-button",
                    onClick: goToStep1
                  }, [
                    _cache[16] || (_cache[16] = _createElementVNode("img", { src: "/server/necs/images/icon_arrow_right_EC7400.svg" }, null, -1)),
                    _createTextVNode(_toDisplayString(_unref(_$t)("common_button_back")), 1)
                  ]),
                  _createElementVNode("p", _hoisted_35, _toDisplayString(_unref(_$t)("diagnosisProcess_msg_diagnosis_info")), 1),
                  _createElementVNode("div", _hoisted_36, [
                    _createElementVNode("div", _hoisted_37, [
                      _createElementVNode("label", _hoisted_38, [
                        _createElementVNode("span", null, _toDisplayString(_unref(_$t)("diagnosisProcess_label_diagnosis_date")), 1),
                        _createElementVNode("span", _hoisted_39, _toDisplayString(_unref(_$t)("common_label_required_icon")), 1)
                      ]),
                      _createElementVNode("p", _hoisted_40, _toDisplayString(_unref(_$t)("diagnosisProcess_msg_date_info")), 1)
                    ]),
                    _createElementVNode("div", _hoisted_41, [
                      _createElementVNode("div", _hoisted_42, [
                        _withDirectives(_createElementVNode("select", {
                          name: "diagnosis-process-date",
                          class: "diagnosis-process-form-date-select",
                          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((diagProcessInput.value.diagnosisYear) = $event))
                        }, [
                          _cache[17] || (_cache[17] = _createElementVNode("option", {
                            value: "",
                            selected: "",
                            disabled: ""
                          }, "----", -1)),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(years.value, (year) => {
                            return (_openBlock(), _createElementBlock("option", {
                              key: year,
                              value: year
                            }, _toDisplayString(year), 9, _hoisted_43))
                          }), 128))
                        ], 512), [
                          [_vModelSelect, diagProcessInput.value.diagnosisYear]
                        ]),
                        _createElementVNode("span", null, _toDisplayString(_unref(_$t)("common_label_year")), 1)
                      ]),
                      _createElementVNode("div", _hoisted_44, [
                        _withDirectives(_createElementVNode("select", {
                          name: "diagnosis-process-date",
                          class: "diagnosis-process-form-date-select",
                          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((diagProcessInput.value.diagnosisMonth) = $event))
                        }, [
                          _cache[18] || (_cache[18] = _createElementVNode("option", {
                            value: "",
                            selected: "",
                            disabled: ""
                          }, "--", -1)),
                          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(12, (month) => {
                            return _createElementVNode("option", {
                              key: month,
                              value: String(month)
                            }, _toDisplayString(String(month).padStart(2, "0")), 9, _hoisted_45)
                          }), 64))
                        ], 512), [
                          [_vModelSelect, diagProcessInput.value.diagnosisMonth]
                        ]),
                        _createElementVNode("span", null, _toDisplayString(_unref(_$t)("common_label_month")), 1)
                      ]),
                      _createElementVNode("div", _hoisted_46, [
                        _withDirectives(_createElementVNode("select", {
                          name: "diagnosis-process-date",
                          class: "diagnosis-process-form-date-select",
                          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((diagProcessInput.value.diagnosisDay) = $event))
                        }, [
                          _cache[19] || (_cache[19] = _createElementVNode("option", {
                            value: "",
                            selected: "",
                            disabled: ""
                          }, "--", -1)),
                          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(31, (day) => {
                            return _createElementVNode("option", {
                              key: day,
                              value: String(day)
                            }, _toDisplayString(String(day).padStart(2, "0")), 9, _hoisted_47)
                          }), 64))
                        ], 512), [
                          [_vModelSelect, diagProcessInput.value.diagnosisDay]
                        ]),
                        _createElementVNode("span", null, _toDisplayString(_unref(_$t)("common_label_day")), 1)
                      ])
                    ]),
                    _createElementVNode("div", {
                      class: _normalizeClass(["input-required-error", { active: fieldErrors.value.diagnosisYear }])
                    }, _toDisplayString(fieldErrors.value.diagnosisYear), 3)
                  ]),
                  _createElementVNode("div", _hoisted_48, [
                    _createElementVNode("div", _hoisted_49, [
                      _createElementVNode("label", null, [
                        _createElementVNode("span", null, _toDisplayString(_unref(_$t)("diagnosisProcess_label_hospital_visits_count_range")), 1)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_50, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.hospitalVisitCountOptions, (option) => {
                        return (_openBlock(), _createElementBlock(_Fragment, {
                          key: option.optionId
                        }, [
                          _withDirectives(_createElementVNode("input", {
                            type: "radio",
                            id: `visit-count-${option.optionId}`,
                            name: "visit-count",
                            value: String(option.optionId),
                            class: "diagnosis-process-form-visit-count-radio",
                            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((diagProcessInput.value.hospitalVisitsCountRangeOptionId) = $event))
                          }, null, 8, _hoisted_51), [
                            [_vModelRadio, diagProcessInput.value.hospitalVisitsCountRangeOptionId]
                          ]),
                          _createElementVNode("label", {
                            for: `visit-count-${option.optionId}`,
                            class: "diagnosis-process-form-visit-count-button"
                          }, _toDisplayString(option.displayName), 9, _hoisted_52)
                        ], 64))
                      }), 128))
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_53, [
                    _createElementVNode("div", _hoisted_54, [
                      _createElementVNode("label", null, [
                        _createElementVNode("span", null, _toDisplayString(_unref(_$t)("diagnosisProcess_label_final_diag_pref")), 1)
                      ]),
                      _createElementVNode("p", _hoisted_55, _toDisplayString(_unref(_$t)("diagnosisProcess_msg_select_area_info")), 1)
                    ]),
                    _createElementVNode("div", _hoisted_56, [
                      _createElementVNode("p", {
                        class: _normalizeClass(["diagnosis-process-form-select-area-label", {
                    'is-selected':
                      diagProcessInput.value.finalDiagPref &&
                      diagProcessInput.value.finalDiagCity,
                  }])
                      }, _toDisplayString(diagProcessInput.value.finalDiagPref &&
                    diagProcessInput.value.finalDiagCity
                      ? diagProcessInput.value.finalDiagPref +
                        " " +
                        diagProcessInput.value.finalDiagCity
                      : _unref(_$t)("diagnosisProcess_label_selected_area")), 3),
                      _createElementVNode("button", {
                        type: "button",
                        class: "diagnosis-process-form-select-area-button",
                        onClick: selectDiagnosisLocation
                      }, [
                        _cache[20] || (_cache[20] = _createElementVNode("img", { src: "/server/necs/images/icon_select_area.svg" }, null, -1)),
                        _createTextVNode(_toDisplayString(_unref(_$t)("common_button_select")), 1)
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_57, [
                    _createElementVNode("div", _hoisted_58, [
                      _createElementVNode("label", null, [
                        _createElementVNode("span", null, _toDisplayString(_unref(_$t)("diagnosisProcess_label_referral_received_pref")), 1)
                      ]),
                      _createElementVNode("p", _hoisted_59, _toDisplayString(_unref(_$t)("diagnosisProcess_msg_select_area_info")), 1)
                    ]),
                    _createElementVNode("div", _hoisted_60, [
                      _createElementVNode("p", {
                        class: _normalizeClass(["diagnosis-process-form-select-area-label", {
                    'is-selected':
                      diagProcessInput.value.refSourcePref &&
                      diagProcessInput.value.refSourceCity,
                  }])
                      }, _toDisplayString(diagProcessInput.value.refSourcePref &&
                    diagProcessInput.value.refSourceCity
                      ? diagProcessInput.value.refSourcePref +
                        " " +
                        diagProcessInput.value.refSourceCity
                      : _unref(_$t)("diagnosisProcess_label_selected_area")), 3),
                      _createElementVNode("button", {
                        type: "button",
                        class: "diagnosis-process-form-select-area-button",
                        onClick: selectReferralLocation
                      }, [
                        _cache[21] || (_cache[21] = _createElementVNode("img", { src: "/server/necs/images/icon_select_area.svg" }, null, -1)),
                        _createTextVNode(_toDisplayString(_unref(_$t)("common_button_select")), 1)
                      ])
                    ])
                  ])
                ]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_61, [
            _createElementVNode("div", _hoisted_62, [
              _createElementVNode("button", {
                type: "button",
                class: "modal-cansel",
                onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.$emit('close')))
              }, _toDisplayString(_unref(_$t)("common_button_cancel")), 1),
              (currentStep.value === 1)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    type: "button",
                    class: "modal-ok",
                    onClick: handleStep1Next
                  }, _toDisplayString(step1ButtonText.value), 1))
                : _createCommentVNode("", true),
              (currentStep.value === 2)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 1,
                    type: "button",
                    class: "modal-ok",
                    onClick: handleStep2SaveClick
                  }, _toDisplayString(_unref(_$t)("common_button_save")), 1))
                : _createCommentVNode("", true)
            ])
          ])
        ])
      ])
    ]),
    (isAreaModalOpen.value)
      ? (_openBlock(), _createBlock(SelectAreaModal, {
          key: 0,
          title: areaModalTitle.value,
          onClose: closeAreaModal,
          onSelect: handleAreaSelect
        }, null, 8, ["title"]))
      : _createCommentVNode("", true),
    (_unref(errorDialog).show)
      ? (_openBlock(), _createBlock(ErrorDialog, _mergeProps({ key: 1 }, _unref(errorDialog), {
          onOk: _unref(errorDialog).close,
          onCancel: _unref(errorDialog).close
        }), null, 16, ["onOk", "onCancel"]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})